import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/context/LanguageContext";
import { ThemeProvider } from "@/context/ThemeContext";
import MinimalHomePage from "@/pages/MinimalHomePage";
import MentionsLegales from "@/pages/MentionsLegales";
import PolitiqueConfidentialite from "@/pages/PolitiqueConfidentialite";
import NotFound from "@/pages/NotFound";
import CityLandingPage from "@/pages/CityLandingPage";
import Blog from "@/pages/Blog";
import BlogArticle from "@/pages/BlogArticle";
import AdsLanding from "@/pages/AdsLanding";
import Realisations from "@/pages/Realisations";
import QuiSommesNous from "@/pages/QuiSommesNous";
import WhatsAppButton from "@/components/WhatsAppButton";
import Analytics from "@/components/Analytics";
import ScrollToTop from "@/components/ScrollToTop";

function App() {
  return (
    <HelmetProvider>
    <ThemeProvider>
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Analytics />
          <Routes>
            <Route path="/" element={<MinimalHomePage />} />
            <Route path="/realisations" element={<Realisations />} />
            <Route path="/qui-sommes-nous" element={<QuiSommesNous />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogArticle />} />
            <Route path="/mentions-legales" element={<MentionsLegales />} />
            <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
            <Route path="/creation-site-internet/:city" element={<CityLandingPage />} />
            <Route path="/ads" element={<AdsLanding />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
        <WhatsAppButton />
        <Toaster position="bottom-right" richColors />
      </div>
    </LanguageProvider>
    </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
